module.exports = __webpack_public_path__ + "static/img/scroebg.26cb5117.png";